import React from 'react';

import Chip from '@mui/material/Chip';

import { TicketScope } from 'stores/TicketTypeStoreAdapter';

const TicketScopeColor: Record<TicketScope, string> = {
  GLOBAL: '#00838f',
  PRIVATE: '#616161',
};

type Props = {
  scope: TicketScope;
  size?: 'small' | 'medium';
};

/** スコープ（グローバル/プライベート）を表示するチップ */
const TicketScopeChip: React.FC<Props> = ({ scope, size = 'small' }) => {
  const color = TicketScopeColor[scope];
  return (
    <Chip
      label={TicketScope[scope]}
      size={size}
      variant="outlined"
      sx={{
        color,
        borderColor: color,
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default TicketScopeChip;
